/*!jslint
  this
*/
jQuery(function ($) {
  "use strict";

  $(document).on("click", ".nav-toggle", function () {
    $("html").toggleClass("nav-open");
    if (!$("html").hasClass("nav-open")) {
      resetMobileMenu();
    }
  });

  // Add placeholder on search input from tablepress
  $("table.tablepress").on("init.dt", function () {
    $("div.dt-search input").attr("placeholder", "Search…");
    // $('div.dt-search label').
  });

  // Download csv function
  $(document).on("click", ".download-csv", function (e) {
    e.preventDefault();

    const tableId = $(this).data("id");

    if (!tableId) return;

    const url = `${sahamati_ajax_object.ajaxurl}?action=custom_export_table&table_id=${tableId}`;

    // Trigger CSV download

    const a = document.createElement("a");

    a.href = url;

    a.download = `table-${tableId}.csv`;

    document.body.appendChild(a);

    a.click();

    document.body.removeChild(a);
  });

  $(document).on("click", ".mobile-nav .back-btn", function () {
    resetMobileMenu();
  });

  $(".mobile-menu > li.menu-item-has-children > a").on("click", function (e) {
    e.preventDefault();
    $(this).closest("li").siblings().hide().removeClass("active");
    $(this).closest("li").addClass("active");
    $(this).next("ul").addClass("active").show();
    $(this).hide();
    if ($(".mobile-nav .back-btn").length === 0) {
      $(".mobile-nav").prepend('<div class="back-btn">&lt; Back</div>');
    }
  });
  function resetMobileMenu() {
    $(".mobile-menu > li").show().removeClass("active");
    $(".mobile-menu ul.sub-menu.active").hide().removeClass("active");
    $(".mobile-menu > li > a").show();
    $(".mobile-nav .back-btn").remove();
  }

  $(".finance-rtl").slick({
    dots: false,
    infinite: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 10000,
    slidesToShow: 3,
    slidesToScroll: 1,
    rtl: true,
    variableWidth: true,
    cssEase: "linear",
  });

  $(".finance-ltr").slick({
    dots: false,
    infinite: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 10000,
    slidesToShow: 3,
    slidesToScroll: 1,
    variableWidth: true,
    cssEase: "linear",
  });

  const arrowIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M10 6l6 6-6 6-1.4-1.4L13.2 12 8.6 7.4 10 6z" fill="#2A2A2A"/></svg>`;
  $(".testimonial-cl").slick({
    dots: false,
    infinite: true,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 5000,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: `<button type="button" class="slick-prev" aria-label="Previous">${arrowIcon}</button>`,
    nextArrow: `<button type="button" class="slick-next" aria-label="Next">${arrowIcon}</button>`,
  });

  $(".hlogos-cl").slick({
    dots: false,
    infinite: true,
    arrows: false,
    autoplay: true,
    pauseOnHover: true,
    autoplaySpeed: 1000,
    slidesToShow: 5,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  });

  // $(".jsCounter").each(function () {
  //   $(this)
  //     .prop("Counter", 0)
  //     .animate(
  //       {
  //         Counter: $(this).text(),
  //       },
  //       {
  //         duration: 6000,
  //         easing: "swing",
  //         step: function (now) {
  //           now = Number(Math.ceil(now)).toLocaleString("en");
  //           $(this).text(now);
  //         },
  //       }
  //     );
  // });

  $(".year-category").click(function (e) {
    e.preventDefault();
    $(".category a").removeClass("active");
    $(this).addClass("active");
    var $tgt = ".team-items";
    var newUrl = $(this).attr("href");

    $("<div>").load(newUrl, function () {
      $($tgt).html($(this).find($tgt).html());
    });
  });
  $(document).on("click", ".tab-list a", function (e) {
    e.preventDefault();
    var href = $(this).attr("href");
    $(".tab-list a").removeClass("active");
    $(this).addClass("active");
    $(".tab-content-item").hide();
    $(href).show();
  });

  $(document).on("click", ".tabmember-tab a", function (e) {
    e.preventDefault();
    var href = $(this).attr("href");
    $(".tabmember-tab a").removeClass("active");
    $(this).addClass("active");
    $(".tabmember-cnt").hide();
    $(href).show();
    $(window).scrollTop($(window).scrollTop() + 1);
  });
  $(".faq-header").on("click", function () {
    const $item = $(this).closest(".faq-cnt-item");

    // If this item is already open, just close it
    if ($item.hasClass("open")) {
      $item.removeClass("open");
      $item.find(".faq-desc").slideUp(300);
      $item.find(".arrow").removeClass("rotate");
    } else {
      // Close all other items first
      $(".faq-cnt-item").removeClass("open").find(".faq-desc").slideUp(300);
      $(".faq-cnt-item").find(".arrow").removeClass("rotate");

      // Then open the clicked one
      $item.addClass("open");
      $item.find(".faq-desc").slideDown(300);
      $item.find(".arrow").addClass("rotate");
    }
  });

  $(".videofigma-btn").on("click", function () {
    const $item = $(this).parent();
    $item.find(".videofigma-btn-list").slideToggle(300);
    $item.toggleClass("activebtn");
    $(this).find(".arrow").toggleClass("rotate");
  });

  // Robust tab activation supporting hashes that point to the pane OR to the nav element's ID.
  function activateContentblockTab(hash) {
    if (!hash) return false;

    // If passed a full URL, extract fragment
    if (typeof hash === "string" && hash.indexOf("#") > 0) {
      hash = "#" + hash.split("#").pop();
    }
    if (hash.charAt(0) !== "#") hash = "#" + hash;

    // Try to find a pane with this id
    var $pane = $(hash);

    // If no pane found, maybe the hash is the ID of a nav link (<a id="nav-1" href="#pane-1">)
    if (!$pane.length) {
      var navId = hash.replace("#", "");
      var navEl = document.getElementById(navId);
      if (navEl && navEl.matches && navEl.matches(".contentblock-tab-nav")) {
        var href = navEl.getAttribute("href") || "";
        if (href.indexOf("#") > -1) {
          hash = href.indexOf("#") === 0 ? href : "#" + href.split("#").pop();
        }
        $pane = $(hash);
      }
    }

    if (!$pane.length) return false;

    var $contentblock = $pane.closest(".contentblock");
    $contentblock.find(".contentblock-tab-content").removeClass("active");
    $pane.addClass("active");
    $contentblock.find(".contentblock-tab-nav").removeClass("active");
    $contentblock
      .find('.contentblock-tab-nav[href="' + hash + '"]')
      .addClass("active");
    return true;
  }

  // Click handler: activate and push new history entry without scrolling
  $(document).on("click", ".contentblock-tab-nav", function (e) {
    e.preventDefault();
    var hash = $(this).attr("href") || "";
    if (!hash) return;

    if (activateContentblockTab(hash)) {
      try {
        if (history && history.pushState) {
          history.pushState(
            null,
            "",
            hash.indexOf("#") === 0 ? hash : "#" + hash
          );
        } else {
          location.hash = hash;
        }
      } catch (err) {
        location.hash = hash;
      }
    }
  });

  // Activate on initial load if a hash is present
  $(window).on("load", function () {
    if (window.location.hash) {
      activateContentblockTab(window.location.hash);
    }
  });

  // Handle popstate/hashchange so back/forward works
  $(window).on("popstate hashchange", function () {
    activateContentblockTab(window.location.hash);
  });

  $(".pdfDropdown").on("change", function () {
    var url = $(this).val();
    if (url) {
      window.open(url, "_blank", "noopener,noreferrer");
      $(this).val("");
    }
  });

  $(".videofigma-video").each(function () {
    var $container = $(this);
    var $video = $container.find(".vf-video");
    var $playBtn = $container.find(".play-btn");

    $playBtn.on("click", function () {
      $video.prop("controls", true);
      $video.prop("muted", false);
      $video.trigger("play");
      $playBtn.fadeOut();
    });
  });
  class CanvasAnimation {
    constructor(canvas, options = {}) {
      this.canvas = canvas;
      this.ctx = canvas.getContext("2d");

      // Default settings
      this.settings = Object.assign(
        {
          pointDensity: 4,
          connections: 2,
          sizeVariation: 0.3,
          velocity: 0.00003,
          maxMovement: 30,
          attractionRange: 0,
          attractionFactor: 0,
          imagePath:
            // "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+PHN2ZyB3aWR0aD0iMjBweCIgaGVpZ2h0PSIxOHB4IiB2aWV3Qm94PSIwIDAgMjAgMTgiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+ICAgICAgICA8dGl0bGU+R3JvdXA8L3RpdGxlPiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4gICAgPGRlZnM+PC9kZWZzPiAgICA8ZyBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4gICAgICAgIDxnIGlkPSJHcm91cCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTAuMDAwMDAwLCA5LjAwMDAwMCkgcm90YXRlKC0zMzAuMDAwMDAwKSB0cmFuc2xhdGUoLTEwLjAwMDAwMCwgLTkuMDAwMDAwKSB0cmFuc2xhdGUoMC4wMDAwMDAsIC0xLjAwMDAwMCkiPiAgICAgICAgICAgIDxwb2x5Z29uIGlkPSJQb2x5Z29uIiBmaWxsPSIjM0MzQTk1IiBwb2ludHM9IjEwIC00LjA2MDI0NDJlLTE0IDE4LjY2MDI1NCA1IDE4LjY2MDI1NCAxNSAxMCAyMCAxLjMzOTc0NTk2IDE1IDEuMzM5NzQ1OTYgNSI+PC9wb2x5Z29uPiAgICAgICAgICAgIDxwb2x5Z29uIGlkPSJQb2x5Z29uIiBmaWxsPSIjM0MzQTk1IiBwb2ludHM9IjEwIDEuNjI0MDk3NjhlLTE0IDE4LjY2MDI1NCA1IDE4LjY2MDI1NCAxNSAxMCAyMCAxLjMzOTc0NTk2IDE1IDkuOTk5OTk5NzYgMTAiPjwvcG9seWdvbj4gICAgICAgICAgICA8cG9seWdvbiBpZD0iUG9seWdvbiIgZmlsbD0iIzNDM0E5NSIgcG9pbnRzPSIxOC42NjAyNTQgMTUgMTAgMjAgMS4zMzk3NDU5NiAxNSA5Ljk5OTk5OTc2IDEwIj48L3BvbHlnb24+ICAgICAgICA8L2c+ICAgIDwvZz48L3N2Zz4="

            "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+PHN2ZyB3aWR0aD0iMjBweCIgaGVpZ2h0PSIxOHB4IiB2aWV3Qm94PSIwIDAgMjAgMTgiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+ICAgICAgICA8dGl0bGU+R3JvdXA8L3RpdGxlPiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4gICAgPGRlZnM+PC9kZWZzPiAgICA8ZyBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4gICAgICAgIDxnIGlkPSJHcm91cCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTAuMDAwMDAwLCA5LjAwMDAwMCkgcm90YXRlKC0zMzAuMDAwMDAwKSB0cmFuc2xhdGUoLTEwLjAwMDAwMCwgLTkuMDAwMDAwKSB0cmFuc2xhdGUoMC4wMDAwMDAsIC0xLjAwMDAwMCkiPiAgICAgICAgICAgIDxwb2x5Z29uIGlkPSJQb2x5Z29uIiBmaWxsPSIjRkZGRkZGIiBwb2ludHM9IjEwIC00LjA2MDI0NDJlLTE0IDE4LjY2MDI1NCA1IDE4LjY2MDI1NCAxNSAxMCAyMCAxLjMzOTc0NTk2IDE1IDEuMzM5NzQ1OTYgNSI+PC9wb2x5Z29uPiAgICAgICAgICAgIDxwb2x5Z29uIGlkPSJQb2x5Z29uIiBmaWxsPSIjRjBGMEYwIiBwb2ludHM9IjEwIDEuNjI0MDk3NjhlLTE0IDE4LjY2MDI1NCA1IDE4LjY2MDI1NCAxNSAxMCAyMCAxLjMzOTc0NTk2IDE1IDkuOTk5OTk5NzYgMTAiPjwvcG9seWdvbj4gICAgICAgICAgICA8cG9seWdvbiBpZD0iUG9seWdvbiIgZmlsbD0iI0U3RTdFNyIgcG9pbnRzPSIxOC42NjAyNTQgMTUgMTAgMjAgMS4zMzk3NDU5NiAxNSA5Ljk5OTk5OTc2IDEwIj48L3BvbHlnb24+ICAgICAgICA8L2c+ICAgIDwvZz48L3N2Zz4=", // your base64
          imgWidth: 30,
          imgHeight: 27,
          // lineColor: "rgba(255,255,255,0.4)",
          lineColor: "rgba(124, 124, 124, 0.1)",
          particleDensity: 0.05,
          particleChance: 0.1,
          particleVelocity: 2,
          // particleVelocity: 10,
          //particleColor: "rgba(255,255,255,0.8)",
          // particleColor: "rgba(124, 124, 124, 0.4)",
          particleColor: " rgba(4, 0, 129, 0.5)",
          particleLength: 10,
          flashRadius: 20,
          flashOpacity: 0.6,
          flashDecay: 0.2,
        },
        options
      );

      this.points = [];
      this.particles = [];
      this.mousePoint = { x: 0, y: 0 };
      this.start = null;
      this.lastTimestamp = null;

      this.img = new Image();
      this.img.src = this.settings.imagePath;

      this.resizeHandler = this.resizeCanvas.bind(this);
      window.addEventListener("resize", this.resizeHandler);

      this.canvas.addEventListener("mousemove", (e) => {
        this.mousePoint.x = e.offsetX;
        this.mousePoint.y = e.offsetY;
      });

      this.resizeCanvas();
      this.createPoints();
      requestAnimationFrame(this.animate.bind(this));
    }

    resizeCanvas() {
      this.canvas.width = this.canvas.clientWidth || window.innerWidth;
      this.canvas.height = this.canvas.clientHeight || window.innerHeight;
      this.createPoints();
    }

    createPoints() {
      this.points = [];
      this.particles = [];
      const s = this.settings;

      for (
        let x = -100;
        x < this.canvas.width + 100;
        x += 1000 / s.pointDensity
      ) {
        for (
          let y = -100;
          y < this.canvas.height + 100;
          y += 1000 / s.pointDensity
        ) {
          let px = Math.floor(x + (Math.random() * 1000) / s.pointDensity);
          let py = Math.floor(y + (Math.random() * 1000) / s.pointDensity);
          let pSizeMod = Math.random() * s.sizeVariation + 1;
          let pw = s.imgWidth * pSizeMod;
          let ph = s.imgHeight * pSizeMod;
          let pAnimOffset = Math.random() * 2 * Math.PI;
          this.points.push({
            x: px,
            originX: px,
            y: py,
            originY: py,
            w: pw,
            h: ph,
            sizeMod: pSizeMod,
            animOffset: pAnimOffset,
            flashOpacity: 0,
          });
        }
      }

      // Find closest points
      for (let p1 of this.points) {
        let closest = [];
        for (let p2 of this.points) {
          if (p1 === p2) continue;
          if (closest.length < s.connections) {
            closest.push(p2);
          } else {
            for (let k = 0; k < s.connections; k++) {
              if (this.getDistance(p1, p2) < this.getDistance(p1, closest[k])) {
                closest[k] = p2;
                break;
              }
            }
          }
        }
        p1.closest = closest;
      }
    }

    animate(timestamp) {
      if (!this.start) {
        this.start = timestamp;
        this.lastTimestamp = timestamp;
      }
      let elapsed = timestamp - this.start;
      let delta = (timestamp - this.lastTimestamp) / 100;
      this.lastTimestamp = timestamp;

      const s = this.settings;

      // Update points
      for (let point of this.points) {
        let attractionOffset = { x: 0, y: 0 };
        let distanceToMouse = this.getDistance(
          { x: point.originX, y: point.originY },
          this.mousePoint
        );

        if (distanceToMouse <= s.attractionRange) {
          let factor =
            ((Math.cos((distanceToMouse / s.attractionRange) * Math.PI) + 1) /
              2) *
            s.attractionFactor;
          attractionOffset.x = factor * (this.mousePoint.x - point.x);
          attractionOffset.y = factor * (this.mousePoint.y - point.y);
        }

        point.x =
          point.originX +
          Math.sin(elapsed * s.velocity + point.animOffset) *
          s.maxMovement *
          point.sizeMod +
          attractionOffset.x;
        point.y =
          point.originY -
          Math.cos(elapsed * s.velocity + point.animOffset) *
          s.maxMovement *
          point.sizeMod +
          attractionOffset.y;
        point.flashOpacity = Math.max(
          0,
          point.flashOpacity - s.flashDecay * delta
        );
      }

      // Update particles
      for (let i = this.particles.length - 1; i >= 0; i--) {
        let particle = this.particles[i];
        let origin = this.points[particle.origin];
        let target = origin.closest[particle.target];
        let distance = this.getDistance(origin, target);
        let dir = {
          x: (target.x - origin.x) / distance,
          y: (target.y - origin.y) / distance,
        };

        particle.traveled += s.particleVelocity * delta;
        particle.direction = dir;
        particle.x = origin.x + dir.x * particle.traveled;
        particle.y = origin.y + dir.y * particle.traveled;

        if ((origin.x - particle.x) * (particle.x - target.x) < 0) {
          this.particles.splice(i, 1);
        }
      }

      // Spawn particles
      for (let i = 0; i < s.particleDensity * this.points.length; i++) {
        if (Math.random() < s.particleChance * delta) {
          let pOriginNum = Math.floor(Math.random() * this.points.length);
          let pOrigin = this.points[pOriginNum];
          let pTargetNum = Math.floor(Math.random() * pOrigin.closest.length);
          this.particles.push({
            origin: pOriginNum,
            target: pTargetNum,
            x: pOrigin.x,
            y: pOrigin.y,
            traveled: 0,
            direction: { x: 0, y: 0 },
          });
          pOrigin.flashOpacity = s.flashOpacity;
        }
      }

      this.drawFrame();
      requestAnimationFrame(this.animate.bind(this));
    }

    drawFrame() {
      const ctx = this.ctx,
        s = this.settings;
      ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);

      for (let p of this.points) this.drawLines(p);

      for (let particle of this.particles) {
        ctx.beginPath();
        ctx.moveTo(particle.x, particle.y);
        ctx.lineTo(
          particle.x - particle.direction.x * s.particleLength,
          particle.y - particle.direction.y * s.particleLength
        );
        ctx.strokeStyle = s.particleColor;
        ctx.stroke();
      }

      for (let point of this.points) {
        if (point.flashOpacity > 0) {
          let gradient = ctx.createRadialGradient(
            point.x,
            point.y,
            s.flashRadius,
            point.x,
            point.y,
            1
          );
          gradient.addColorStop(0, "rgba(255,255,255,0)");
          gradient.addColorStop(
            1,
            "rgba(255,255,255," + point.flashOpacity + ")"
          );
          ctx.fillStyle = gradient;
          ctx.beginPath();
          ctx.rect(
            point.x - s.flashRadius,
            point.y - s.flashRadius,
            s.flashRadius * 2,
            s.flashRadius * 2
          );
          ctx.fill();
        }
        ctx.drawImage(
          this.img,
          point.x - point.w / 2,
          point.y - point.h / 2,
          point.w,
          point.h
        );
      }
    }

    drawLines(p) {
      const ctx = this.ctx,
        s = this.settings;
      for (let c of p.closest) {
        ctx.beginPath();
        ctx.moveTo(p.x, p.y);
        ctx.lineTo(c.x, c.y);
        ctx.strokeStyle = s.lineColor;
        ctx.stroke();
      }
    }

    getDistance(p1, p2) {
      return Math.sqrt((p1.x - p2.x) ** 2 + (p1.y - p2.y) ** 2);
    }
  }

  // Initialize all canvases with class "canvas"
  document.querySelectorAll(".canvas-animation").forEach((canvas) => {
    new CanvasAnimation(canvas);
  });
  function animateCounter($el) {
    let target = parseInt($el.text().replace(/,/g, ""), 10);

    $el.prop("Counter", 0).animate(
      { Counter: target },
      {
        duration: 4000,
        easing: "swing",
        step: function (now) {
          $el.text(Math.ceil(now).toLocaleString("en"));
        },
      }
    );
  }

  new WOW({
    callback: function (el) {
      if (
        $(el).is(".himpact-rt-list .box-card") &&
        !$(el).hasClass("counted")
      ) {
        $(el)
          .find(".jsCounter")
          .each(function () {
            animateCounter($(this));
          });
        $(el).addClass("counted");
      }
    },
  }).init();

  const entitySlabMap = {
    "NBFC, including HFC": ["Upper Layer", "Middle Layer", "Base Layer"],
    "Bank (Private Sector, Public Sector, Foreign and Small Finance)": [
      ">₹10,00,000 crore",
      "₹50,000 – ₹10,00,000 crore",
      "< ₹50,000 crore",
    ],
    "Private and Public Sector Life Insurance": [
      "> ₹10,000 crore",
      "₹1,000 – ₹10,000 crore",
      "< ₹1,000 crore",
    ],
    "Private and Public Sector Non-Life and Health Insurance": [
      "> ₹5,000 crore",
      "₹1,000 – ₹5,000 crore",
      "< ₹1,000 crore",
    ],
    "Stock Brokers / Depository Participant": [
      "> ₹5,000 crore",
      "₹1,000 – ₹5,000 crore",
      "< ₹1,000 crore",
    ],
    "Portfolio Manager (PM)": [
      "> ₹5,000 crore",
      "₹1,000 – ₹5,000 crore",
      "< ₹1,000 crore",
    ],
    "Insurance Broker / Corporate Agent / Insurance Marketing Firm / Web Aggregator":
      ["> ₹100 crore", "₹20 – ₹100 crore", "< ₹20 crore"],
    "Registered Investment Adviser (IA)": [
      "> ₹50 crore",
      "₹25 – ₹50 crore",
      "< ₹25 crore",
    ],
    "Asset Management Company (AMC)": [
      "> ₹1,50,000",
      "₹50,000 – ₹1,50,000",
      "< ₹50,000",
    ],
  };

  const feeMap = { 'category-A': 500000, 'category-B': 125000, 'category-C': 25000 };

  const entityField = "#input_4_24";
  const slabField = "#input_4_23";
  const categoryField = "#input_4_22";
  const feeField = "#input_4_34";

  $(categoryField + ", " + feeField).attr("readonly", true);

  function updateRevenueSlabs(entity) {
    const $slab = $(slabField);
    const $slabParent = $slab.closest(".gfield");
    $slab.empty();

    if (entitySlabMap[entity]) {
      entitySlabMap[entity].forEach((val) =>
        $slab.append(`<option value="${val}">${val}</option>`)
      );
      $slabParent.show().addClass("has-entity");
    } else {
      $slabParent.hide().removeClass("has-entity");
    }
  }

  function updateFee() {
    const entity = $(entityField).val();
    const slab = $(slabField).val();
    let category = "category-C";
    let fee = feeMap["category-C"];

    if (entitySlabMap[entity]) {
      const slabs = entitySlabMap[entity];
      const index = slabs.indexOf(slab);
      category = index === 0 ? "category-A" : index === 1 ? "category-B" : "category-C";
      fee = feeMap[category];
    } else if (entity === "NBFC-AA") {
      category = "category-B";
      fee = feeMap["category-B"];
    }

    $(categoryField).val(category);
    $(feeField).val(fee);
  }

  function initFormState() {
    const entityVal = $(entityField).val();
    if (entityVal) {
      updateRevenueSlabs(entityVal);
      updateFee();
    }
  }

  $(document).on("change", entityField, function () {
    updateRevenueSlabs($(this).val());
    updateFee();
  });

  $(document).on("change", slabField, function () {
    updateFee();
  });

  initFormState();
  $(document).on("gform_post_render", initFormState);

  var $form = $("#gform_4");
  $form.find('input[name="input_1"]').on("change", function () {
    $form
      .find(".re-membership-api")
      .toggle($form.find("#choice_4_3_0").is(":checked"));
  });

  $form.find('input[name="input_3"]').on("change", function () {
    $form.find(".re-membership-api").toggle(false);
  });

  $form
    .find(".re-membership-api")
    .toggle($form.find("#choice_4_3_0").is(":checked"));

  $("#input_4_42").on("input", function () {
    this.value = this.value.toUpperCase().slice(0, 15);
  });

  $(".blog-category").click(function (e) {
    e.preventDefault();
    $("body").addClass("loading");
    $(".categories a").removeClass("active");
    $(this).addClass("active");
    var $tgt = "#blogs";
    var newUrl = $(this).attr("href");
    history.pushState(null, "", newUrl);
    $("<div>").load(newUrl, function () {
      $($tgt).html($(this).find($tgt).html());
      $("body").removeClass("loading");
    });
  });

  const scrollicon = `<svg xmlns="http://www.w3.org/2000/svg" width="9" height="16" viewBox="0 0 9 16" fill="none">
  <path d="M7.49805 0.851562C7.73675 0.851563 7.96597 0.946446 8.13477 1.11523C8.30356 1.28403 8.39844 1.51324 8.39844 1.75195C8.39835 1.99048 8.30339 2.21899 8.13477 2.3877L2.5498 7.97363L2.52246 8.00098L2.5498 8.02832L8.13477 13.6152C8.30356 13.784 8.39844 14.0132 8.39844 14.252C8.39835 14.4905 8.30339 14.719 8.13477 14.8877C7.96597 15.0565 7.73676 15.1514 7.49805 15.1514C7.25946 15.1513 7.03102 15.0564 6.8623 14.8877L0.612305 8.6377C0.528546 8.55423 0.461362 8.45491 0.416016 8.3457C0.37085 8.23674 0.347699 8.11991 0.347656 8.00195C0.347656 7.88379 0.370733 7.76637 0.416016 7.65723C0.461362 7.54802 0.528546 7.4487 0.612305 7.36523L6.8623 1.11523C7.031 0.946616 7.25953 0.851655 7.49805 0.851562Z" fill="#475569" stroke="#475569" stroke-width="0.078125"/>
  </svg>`;

  $('.quotes-cl').on('init', function (event, slick) {
    $(this).find('.slick-dots').each(function () {
      if (!$(this).parent().hasClass('dot-wrap')) {
        $(this).wrap('<div class="dot-wrap"></div>');
      }
    });
  });

  const $slider = $(".quotes-cl");
  const slideCount = $slider.children().length;
  $slider.slick({
    dots: slideCount > 1,
    arrows: true,
    infinite: true,
    autoplay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    // adaptiveHeight: true,
    prevArrow: `<button type="button" class="slick-prev" aria-label="Previous">${scrollicon}</button>`,
    nextArrow: `<button type="button" class="slick-next" aria-label="Next">${scrollicon}</button>`,
    appendArrows: $(".quotes-controls"),
    appendDots: $(".quotes-controls"),
  });

  // PLAY the video
  $(document).on("click", ".video-play-btn", function (e) {
    e.stopPropagation();

    const $wrapper = $(this).closest(".video-wrapper");
    const video = $wrapper.find(".video-player").get(0);
    const $cover = $wrapper.find(".video-cover");
    const $btn = $wrapper.find(".video-play-btn");

    video.play();
    $cover.addClass("hidden");
    $btn.addClass("hidden");
  });

  $(document).on("click", ".video-player", function (e) {
    e.stopPropagation();

    const $wrapper = $(this).closest(".video-wrapper");
    const video = this;
    const $cover = $wrapper.find(".video-cover");
    const $btn = $wrapper.find(".video-play-btn");

    video.pause();
    $cover.removeClass("hidden");
    $btn.removeClass("hidden");
  });

  $(".vq-slider-vdo").slick({
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
  });

  $(".vq-slider-quotes").slick({
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
  });

  const $slider_vdo = $(".vq-slider-vdo");
  const $videos = $slider_vdo.find("video");
  const first = $videos[0];

  if (first) {
    first.muted = true;
    first.play().catch(() => { });
  }

  $slider_vdo.on("beforeChange", () => $videos.each((_, v) => v.pause()));

  $videos.on("click", function () {
    $videos.not(this).each((_, v) => v.pause());
    this.muted = false;
    this.paused ? this.play() : this.pause();
  });
});
